import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  Details = 'Details',
  AgreementOptions = 'AgreementOptions',
  CampaignAccess = 'CampaignAccess',
  SameOrgAdvisors = 'SameOrgAdvisors',
}
export const queryKeys = {
  campaigns: () => [QueryFeature.Campaigns],
  campaignDetails: (campaignId?: string) => [QueryFeature.Campaigns, QueryKey.Details, campaignId],

  campaignAccess: (campaignId?: string) => [
    QueryFeature.Campaigns,
    QueryKey.CampaignAccess,
    campaignId,
  ],

  sameOrgAdvisors: () => [QueryFeature.Campaigns, QueryKey.SameOrgAdvisors],

  agreementOptions: (campaignId: string | null) => [
    QueryFeature.Campaigns,
    QueryKey.AgreementOptions,
    campaignId,
  ],
};
